import { Component, ViewChild } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { Apollo } from 'apollo-angular';
import { CookieService } from 'ngx-cookie-service';
import { DataService } from '../../../services/data/data.service';

import moment from 'moment';
import ApexCharts from 'apexcharts';
import { IMG } from '../../../services/exportIm/png';
import { Aligment, ExcelService, FormatText } from '../../../services/excel/excel.service';
import html2canvas from 'html2canvas';
import { ConstantesImagenes } from '../../../models/Cuestionarios/codigoimagenes';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
// Registrar fuentes virtuales
pdfMake.addVirtualFileSystem(pdfFonts);
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { typesApex } from '../../../components/models';
import { GraficadorComponent } from '../../../components/graficador/graficador.component';
import { messages } from '../../funciones/mensajes';
@Component({
  selector: 'app-calificacion',
  templateUrl: './calificacion.component.html',
  styleUrl: './calificacion.component.css'
})
export class CalificacionComponent {
  private headers = new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('token'));  

  public allocationId = undefined;
  private questionaryId = undefined;
  public questionarySelect = undefined;
  public allocations = [];
  private answersSheet = [];
  private institutionId = 0;
  public semaforos = [];
  public tableShow = [];
  flatTableShow: any[] = [];
  public showQuestions = [];
  public preguntasArray = [];
  public sort = 'asc';

  private colorMulti: any = ['#2843A0','#15A075','#36CAE8','#78EAD2','#F88476','#E23E6A'];
  public options: any = {};
  public chart;
  private renderGraf = false;
  public encabezadoGraf1 = '';
  public options2: any = {};
  public chart2;
  private renderGraf2 = false;
  public chartAmp;
  public renderGrafAmp = false;
  public renderTabAmp = false;
  public titleModal = "";
  public chartExp;
  private optionsExp: any = {};
  legends = false;
  
  public tipo = '';
  public isFunel = false;
  public labelsG1 = false;
  public labelsG2 = false;
  public semaforosLabels:String[]= ['Efectivo', 'Confiable','Poco confiable'];

  //variables reporte
  // public image = new Map<String, String>();
  public image;
  public reporteGeneradoExitosamente: boolean = true;
  public isDownloadingPdf = false;
  private reportName = 'Reporte.pdf';
  private imgLogo;
  private pdfFile: any;
  private allocation;
  iconColor: any;

  constructor(
    public dataService: DataService,
    private apollo: Apollo,
    private cookieService: CookieService,
    private translate: TranslateService,
    private excel: ExcelService,
    private route: Router,
  ){
    moment.updateLocale('en',{
      months: [
        "Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto",
        "Septiembre","Octubre","Noviembre","Diciembre"
      ],
      monthsShort: [
        "Ene","Feb","Mar","Abr","May","Jun","Jul","Ago",
        "Sep","Oct","Nov","Dic"
      ]
    });
  }

  ngOnInit(){
    this.getInformation();
  }
  /* Consultas */
  private async getInformation(){
    this.answersSheet = JSON.parse(localStorage.getItem('answers'));
    this.allocation = JSON.parse(localStorage.getItem('allocation'));
    const cuestionario = JSON.parse(localStorage.getItem('cuestionario'));

    var eleme = this.ListelementosCategories(cuestionario.categories, null);
    var peso = 0, numPreg = 0;
    for(const e of eleme){
      peso += e.ponderacion*e.peso/100;
      numPreg += e.numPreg;
    }

    this.semaforos = [];
    var aux = JSON.parse(JSON.stringify(cuestionario.semaphores));
    aux.sort( function(a,b){
      if ( Number(a.value_1) < Number(b.value_1) ) {
        return 1;
      }
      if ( Number(a.value_1) > Number(b.value_1) ) {
        return -1;
      }
      return 0;
    });
    var titN = 1;

    for(const sem of aux){
      var name = this.translate.instant('cues.resultados.titulo-semaforo-'+titN);
      if(name === ('cues.resultados.titulo-semaforo-'+titN)){
        name = '';
      }
      this.semaforos.push({
        name: name,
        min: sem.value_1,
        max: sem.value_2,
        color: sem.color
      });
      titN++;
    }

    peso = Number(peso.toFixed(1));

    this.questionarySelect = {
      id: cuestionario.id,
      name: cuestionario.name,
      elementos: eleme,
      ponderacion: peso,
      numPreg: numPreg,
    }
    const semaforoMatch = this.semaforos.find(s => s.min <= this.questionarySelect.ponderacion && this.questionarySelect.ponderacion <= s.max);
    this.iconColor = semaforoMatch ? semaforoMatch.color : '#ffffffff';
    this.tableLevels();
    this.treeMapGraf('radar',false, false);
    // this.exportPreguntasRespuestas();
  }
  /* obtención elementos */
  private ListelementosCategories(elements, id){
    var elementos = [];
    var cat;
    if(id === null){
      cat = elements.filter( e => e.parent === id);
    }else{
      cat = elements.filter( e => e.parent !== null && e.parent.id === id);
    }

    cat.sort(function(a,b){
      if ( Number(a.id) > Number(b.id) ) {
        return 1;
      }
      if ( Number(a.id) < Number(b.id) ) {
        return -1;
      }
      return 0;
    });

    for(const e of cat){
      const quest = this.structureQuestions(e.questions);
      const eleme = this.ListelementosCategories(elements, e.id);
      var peso = 0, numPreg = 0, numPregReales = 0, ponderacionMax = 0;
      if(quest.length !== 0){
        for(const q of quest){
          if(q.aplica){
            peso += q.ponderacion*q.peso/100;
            ponderacionMax += q.peso;
            numPregReales++;
          }
          numPreg++;
        }
        peso = peso*100/ponderacionMax;

      }else if(eleme.length !== 0){
        for(const e of eleme){
          peso += e.ponderacion*e.peso/100;
          numPreg += e.numPreg;
        }
      }
      peso = Number(peso.toFixed(1));

      elementos.push({
        id: e.id,
        name: e.name,
        description: e.description,
        parent: e.parent,
        numPreg: numPreg,
        elementos: eleme,
        questions: quest,
        ponderacion: peso,
        peso: e.weighting
      });
    }
    return elementos;
  }
  private structureQuestions(questions){
    var newQuestions = [];

    for(const q of questions){
      var res = [];
      for(const r of q.answers_options){
        res.push({
          id: r.id,
          respuesta: r.description,
          score: r.score,
        });
      }
      const answer = this.answersSheet.find(c => c.idQuestion === q.id);
      var valor = 0;
      var aplica = true;

      try{
        const respuesta = res.find(c => c.id === answer.idAnswer).respuesta;
        if(respuesta.toLowerCase() === 'no aplica' || respuesta.toLowerCase() === 'no le aplica'){
          aplica = false;
        }
        valor = res.find(c => c.id === answer.idAnswer).score*10/10;
      }catch(err){
      }

      valor = Number(valor.toFixed(1));
      
      
      newQuestions.push({
        id: q.id,
        descripcion: q.description,
        order: q.order,
        requerida: q.required,
        respuestas: res,
        ponderacion: valor,
        peso: q.weighting,
        respuesta: answer?.idAnswer??0,
        aplica
      });
    }

    newQuestions.sort(function(a,b){
      if ( Number(a.id) < Number(b.id) ) {
        return -1;
      }
      if ( Number(a.id) > Number(b.id) ) {
        return 1;
      }
      return 0;
    });

    return newQuestions;
  }
  /* Array de preguntas para planes */
  public addOrRemoveItem(item){
    const ex = this.preguntasArray.find(p => p.idQuestion === item.id);
    if( ex ){
      this.preguntasArray = this.preguntasArray.filter(p => p.idQuestion !== item.id);
    }else{
      this.preguntasArray.push({
        idQuestion: item.id,
      });
    }
  }
  public openGantt(){
    this.route.navigateByUrl('app/resultados/planes', { state: this.preguntasArray });
  }
  /* Graficas */
  colores = [];
  type = '';
  private typesGraf = typesApex;
  data = [];
  labels = [];
  @ViewChild('graficador1') graficador1: GraficadorComponent;
  

  public multBarGraf(){
    var data = [];
    var titles = [];
    var max = 0;
    this.encabezadoGraf1 = '';    
    for(const com of this.questionarySelect.elementos){
      if(com.elementos.length > max ){
        max = com.elementos.length;
      }
    }

    for(var i = 0; i<max; i++){
      data.push({
        name: "",
        data: [],
        extra: this.questionarySelect
      });
    }

    for(const com of this.questionarySelect.elementos){    
      if(com.name.length > 20){
        var aux = [];
        for(var i = 0; i <= com.name.length/20; i++){
          if((i+1)*20 > com.name.length){
            aux.push(com.name.slice(i*20));
          }else{
            aux.push(com.name.slice(i*20,(i+1)*20));
          }
        }
        titles.push(aux);
      }else{
        titles.push(com.name);
      }

      var i = 0;
      for(const el of com.elementos){
        data[i].data.push(el.ponderacion);
        i++;
      }
      if(i<max){
        for(var j = i; j<max; j++){
          data[j].data.push(0);
        }
      }
    }

    this.options = {
      series: data,
      xaxis: {
        categories: titles,
        labels: {
          maxHeight: 20,
          rotate: 0,
          trim: true
        },
        tooltip:{
          enabled: false,
          theme: "dark"
        },
      },
      yaxis: {
        labels: {
          show: true,
          style: {
            fontSize: '16px',
            fontWeight: 400,
          },
        },
      },
      chart: {
        type: "bar",
        width: "100%",
        height: "100%",
        toolbar: {
          show: false
        },
        zoom: {
          enabled: false
        },
        animations: {
          enabled: true
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "90%",
          borderRadius: 5,
          borderRadiuesApplication: 'end',
          dataLabels: {
            position: "top",
          },
        }
      },
      colors: this.colorMulti,
      fill: {
        opacity: 0.8
      },
      grid: {
        show: false
      },
      dataLabels: {
        enabled: this.labelsG1,
        position: "top",
        offsetY: -20,
        style: {
          fontSize: "12px",
          colors: ["#304758"]
        },
        formatter: function (val, opt) {
          return val!==0 ? val: '';
        },
      },
      markers: {
        size: 6,
        hover: {
          size: 6
        },
        fillOpacity: 1
      },
      stroke:{
        show: true,
        curve: "smooth"
      },
      
      tooltip: {
        y: {
          formatter: function(val, {seriesIndex}) {
            return val;
          }
        },
        x: {
          formatter: function(val, {seriesIndex, w }) {
            let imp = '';
            if(Array.isArray(val)){
              let valAux = '';
              for(const d of val){
                valAux += d;
              }
              val = valAux;
            }
            const com = w.config.series[0].extra.elementos.find(c => c.name === val);
            return 'Componente: '+val+'<br>Elemento: '+com.elementos[seriesIndex].name;
          }
        },
      },
      legend: {
        show: false
      }
    };

    if(this.renderGraf){
      this.chart.destroy();
    }
    setTimeout(() =>{  
      this.chart = new ApexCharts(
        document.querySelector("#grafica2"),//id del div 
        this.options
      );
      this.chart.render();
      this.renderGraf = true;
      this.options.stroke["show"] = true;
    }, 100);
  }
  public grafBarr(elements){
    this.encabezadoGraf1 = elements.name;
    var color = [];
    var data = [], dat = [], etiquetas = [];
    if(elements.elementos.length !== 0){
      for(const el of elements.elementos){
        dat.push(el.ponderacion);
          etiquetas.push(el.name);
        var col = this.semaforos.find(s => s.min <= el.ponderacion && el.ponderacion <= s.max).color;
        color.push(col);
      }
    }else{
      for(const el of elements.questions){
        dat.push(el.ponderacion);
          etiquetas.push(el.descripcion);
        var col = this.semaforos.find(s => s.min <= el.ponderacion && el.ponderacion <= s.max).color;
        color.push(col);
      }
    }

    var chartType = this.tipo === 'barHorizontal' ? 'bar' : this.tipo;
    var dataForChart = [];
    
    if(chartType === 'radar'){
      // Para radar, crear una sola serie con todos los elementos
      // Cambiar color a azul celeste solo para radar
      color = ['#36CAE8'];
      dataForChart.push({
        name: elements.name,
        data: dat.map(d => d)
      });
    }else{
      dataForChart.push({
        name: elements.name,
        data: dat,
      });
    }

    this.type = this.tipo;
    this.labels = etiquetas;
    this.data = dataForChart;
    this.colores = color;

    if(this.tipo === 'radar'){
      this.labelsG2 = true;
      this.legends = true;
    }else{
      this.legends = false;
    }
  }
  public etiquetasGraf1(labels){
    this.labelsG1 = labels;
    if(this.renderGraf){
      this.chart.destroy();
    }

    this.options.dataLabels.enabled = this.labelsG1;

    setTimeout(() =>{  
      this.chart = new ApexCharts(
        document.querySelector("#grafica"),//id del div 
        this.options
      );
      this.chart.render();
      this.renderGraf = true;
      this.options.stroke["show"] = true;
    }, 100);
  }
  private getColor(ponderacion: number): string {
    try {
      return this.semaforos.find(
        s => s.min <= ponderacion && ponderacion <= s.max
      )?.color || '#ffffff';
    } catch {
      return '#ffffff';
    }
  }

  private buildNode(node: any): any {
    const result: any = {
      name: node.name,
      ponder: node.ponderacion,
      numPreg: node.numPreg,
      color: this.getColor(node.ponderacion),
      opened: false
    };
    if (node.questions?.length) {
      result.preg = node.questions.map((p: any) => ({
        name: p.descripcion,
        id: p.id,
        ponder: p.ponderacion,
        color: this.getColor(p.ponderacion),
        aplica: p.aplica
      }));
    }
    if (node.elementos?.length) {
      result.subelements = node.elementos.map((child: any) =>
        this.buildNode(child)
      );
    }
    return result;
  }

  tableFull(nodes: any[]): any[] {
    const result: any[] = [];
    const process = (node: any, level: number) => {
      result.push({
        node,
        level
      });

      if (node.opened && node.subelements?.length) {
        node.subelements.forEach((child: any) =>
          process(child, level + 1)
        );
      }
    };
    nodes.forEach(node => process(node, 0));
    return result;
  }
  refreshTable(): void {
    this.flatTableShow = this.tableFull(this.tableShow);
  }

  private tableLevels() {
    this.tableShow = this.questionarySelect.elementos.map((element: any) =>
      this.buildNode(element)
    );
    this.tableShow.forEach(e => e.opened=true);
    this.refreshTable();
  }

  toggleNode(node: any): void {
    node.node.opened = !node.node.opened;

    this.refreshTable();
  }
  public treeMapGraf(tipo: string, isFunel: boolean, labels: boolean){
    this.encabezadoGraf1 = '';
    this.labelsG2 = labels;
    this.tipo = tipo;
    this.isFunel = isFunel;
    var color = [];
    var data = [], dat = [], etiquetas = [];
    for(const el of this.questionarySelect.elementos){
      dat.push(el.ponderacion);
      // if(el.name.length > 40){
      //   var aux = [];
      //   for(var i = 0; i <= el.name.length/40; i++){
      //     if((i+1)*40 > el.name.length){
      //       aux.push(el.name.slice(i*40));
      //     }else{
      //       aux.push(el.name.slice(i*40,(i+1)*40));
      //     }
      //   }
      //   etiquetas.push(aux);
      // }else{
        etiquetas.push(el.name);
      // }
      var col = this.semaforos.find(s => s.min <= el.ponderacion && el.ponderacion <= s.max).color;
      color.push(col);
    }
    
    if(tipo == 'bar'){
      data.push({
        name: "",
        data: dat,
        extra: etiquetas
      });
    }else if(tipo === 'radar'){
      // Cambiar color a azul celeste solo para radar
      color = ['#36CAE8'];
      data.push({
        name: "",
        data: dat.map(d => d)
      });
    }else if(tipo === 'barHorizontal'){
      data.push({
        name: "",
        data: dat,
        extra: etiquetas
      });
    }
    let lab;
    var legends = false;

    this.type = tipo;
    this.labels = etiquetas;
    this.data = data;
    this.colores = color;

    if(tipo === 'radar'){
      legends = true;
      this.labelsG2 = true;
      this.legends = true;
    }else{
      this.legends = false;
    }
  }
  public etiquetas(labels){
    this.labelsG2 = labels;
  }
  /* Exportaciones */
  public async exportImagen(id,name){
    const titulos = {
      titulo: '',
      subtitulo: '',
      nombreArch: name
    };

    if (this.graficador1) {
      this.graficador1.exportImg(1, titulos);
    }
  }
  public exportarExcel(){
    var encabezado = [
      this.translate.instant('cues.resultados.titulo-table-1'),
      this.translate.instant('cues.resultados.titulo-table-2'),
      this.translate.instant('cues.resultados.titulo-table-3')
    ];
    const data: any[] = [];
    var color = [];

    const processNode = (inf: any) => {
      var aux = [];
      aux.push(inf.name);
      aux.push(inf.numPreg);
      aux.push(inf.ponder);
      data.push(aux);
      color.push(inf.color);
      if (inf.subelements?.length) {
        for (const child of inf.subelements) {
          processNode(child);
        }
      }
    };

    for(const elem of this.tableShow){
      processNode(elem)
    }
    this.excel.generateTableResultados('Tabla_1',encabezado,data,'Tabla_1', color);
  }
  /* eventos */
  printDate(date){
    return moment(date).format('MMM-YY')
  }
  /* Modal */
  //Abrir modal
  modal = false;
  public async openModal(graf){
    // document.getElementById("ampliar")!.style.display = "block";
    this.modal = true;
    console.time('implementación')
    await setTimeout(() =>{
      switch(graf){
        case 1:
          this.renderGrafAmp = true;
          break;
        case 3:
          this.renderTabAmp = true;
          this.titleModal = "";
          break;
      }
      console.timeEnd('implementación')
    },100)
  }
  //Cerrar modal ampliar grafica
  public closeModal(){
    // document.getElementById("ampliar")!.style.display = "none";
    this.modal = false;
    this.renderGrafAmp = false;
    this.renderTabAmp = false;
  }
  //detecta el click fuera del modal y cierra 
  public clickFuera(event){
    if (event.target === document.getElementById("ampliar")) {
      this.closeModal();
    }
  }

  public async descargarReporte(){
    try{
      messages.messageSaving(this.translate.instant('acciones.descarga'),this.translate.instant('acciones.espera'))
      await this.generarImagenes();
      this.image

      this.isDownloadingPdf = true;
      this.reporteGeneradoExitosamente = false;
      const fechaPiePag = new Date().toLocaleDateString('es-MX', {month: '2-digit',day: '2-digit',year: '2-digit',});
      const horaPiePag = new Date().toLocaleTimeString('es-MX');
      const currentUser = this.dataService.user;
      const colorCalif = this.semaforos.find(s => s.min <= this.questionarySelect['ponderacion'] && this.questionarySelect['ponderacion'] <= s.max).color
      const docPDF = {
        pageSize: 'FOLIO',
        images: {
          logoAleema: ConstantesImagenes.fondoblanco,
        },
        footer: function (currentPage, pageCount){
          if(currentPage == 1){
            return null;
          }
          if(currentPage === pageCount){
            return{
              columns: [
                {
                  image: 'logoAleema',
                  width: 70,
                  margin: [30, -1, 30, 0],
                },
                {
                  text: `${currentUser}  |  ${fechaPiePag}  |  ${horaPiePag}`,
                  alignment: 'center',
                  width: '*',
                  color: '#808080',
                  fontSize: 10,
                },

                {
                  text: (currentPage - 1).toString(),
                  color: '#808080',
                  fontSize: 10,
                  width: 'auto',
                  margin: [10, -1, 30, 0],
                },
              ]
            }
          }else{
            return{
              text: {
                  text: (currentPage - 1).toString(),
                  alignment: 'right',
                  color: '#808080',
                  fontSize: 10,
                  width: 'auto',
                },margin: [10, -1, 30, 0],
            }
          }
        },
        content: [
          this.imgLogo !== '' && this.imgLogo !== undefined ? {
            image: this.imgLogo,
            width: 220,
            margin: [0, 0, 10, 0],
            absolutePosition: { y: 60 },
            alignment: 'right',
          } : { text: '' },
          {
            text: 'Resultados',
            style: 'header',
            bold: true,
            fontSize: 30,
            color: 'black',
            margin: [60, 250, 0, 0],
          },
          {
            text: this.questionarySelect.name,
            style: 'header',
            bold: true,
            fontSize: 30,
            color: 'black',
            margin: [60, 5, 0, 0],
          },
          {
            text: ['Calificación: ',{ text:this.questionarySelect['ponderacion'],color: colorCalif}],
            style: 'header',
            bold: true,
            fontSize: 20,
            color: 'black',
            margin: [60, 25, 0, 0],
          },
          // {
          //   // text: moment(this.questionarySelect.fechaIni,'DD/MM/YYYY').format("MMM YYYY"),
          //   style: 'header',
          //   bold: true,
          //   fontSize: 18,
          //   color: 'black',
          //   margin: [60, 45, 0, 0],
          // },
          [
            {text: '', pageBreak: 'after'}
          ],          
          this.image !== undefined ? {
            // image: this.image.get('1'),
            image: this.image,
            width: 500,
            margin: [0, 0, 10, 0],
            alignment: 'center',
          } : { text: '' },
        ]
      }
      this.reporteGeneradoExitosamente = true;
    
      this.reportName = 'Reporte '+this.questionarySelect.name+'.pdf';
      
      const pdf = pdfMake.createPdf(docPDF);
      await pdf.download(this.reportName);
      const blob = await pdf.getBlob();
      this.pdfFile = blob;
      Swal.close();
      messages.succesMessageGraph(this.translate.instant('acciones.desExito'))
      setTimeout(() => {
        this.isDownloadingPdf = false;
      }, 2000);
    }catch(error){
      this.reporteGeneradoExitosamente = false;
      Swal.close();
      Swal.fire({title: this.translate.instant('cues.resultados.titulo-error'), timer: 20000});
    }
  }

  public async generarImagenes(){
    await html2canvas(
      document.querySelector('#graf1'),
      {scale: 1}
    ).then((canvas)=> {
      // this.image.set('1',canvas.toDataURL());
      this.image = canvas.toDataURL();
    })
  }
  /* ordenamiento */
  public orderQuestions(){
    if(this.sort === 'asc'){
      this.sort = 'desc';
    }else{
      this.sort = 'asc';
    }
    if(this.sort === 'desc'){
      this.showQuestions.sort(function(a,b){
        if ( Number(a.ponder) < Number(b.ponder) ) {
          return -1;
        }
        if ( Number(a.ponder) > Number(b.ponder) ) {
          return 1;
        }
        return 0;
      });
    }else{
      this.showQuestions.sort(function(a,b){
        if ( Number(a.id) < Number(b.id) ) {
          return -1;
        }
        if ( Number(a.id) > Number(b.id) ) {
          return 1;
        }
        return 0;
      });
    }
  }
  //Evento click
  public mostrarAnswers(elem){
    this.showQuestions = elem.preg;
    document.getElementById("ampliarPreg")!.style.display = "block";
  }
  public clickFueraP(event){
    if (event.target === document.getElementById("ampliarPreg")) {
      this.closeModalP();
    }
  }
  public closeModalP(){
    document.getElementById("ampliarPreg")!.style.display = "none";
  }
  //Exportación calificación preguntas y respuestas
  // public exportPreguntasRespuestas(){
  //   var tab = [];
  //   for(const elements of this.questionarySelect.elementos){
  //     var aux = [];

  //     aux.push(elements.name)
  //     aux.push('')
  //     aux.push(elements.ponderacion)
  //     tab.push(aux);
  //     aux = [];
  //     for(const subElements of elements.elementos){
  //       aux.push(subElements.name)
  //       aux.push('')
  //       aux.push(subElements.ponderacion)
  //       tab.push(aux);
  //       aux = [];
  //       for(const questions of subElements.questions){
  //         aux.push(questions.descripcion)
  //         aux.push(questions.respuestas.find(r => Number(r.id) === Number(questions.respuesta))?.respuesta??'-')
  //         aux.push(Number(questions.ponderacion))
  //         tab.push(aux);
  //         aux = [];
  //       }
  //     }
  //   }

  //   var headers = ['Categoria / Elemento / Prrgunta', 'Respuesta', 'Ponderación'];
  //   var formato = [FormatText.TEXT, FormatText.TEXT, FormatText.NUMBERDEC];
  //   var aligment = [Aligment.LEFT, Aligment.LEFT, Aligment.RIGHT];

  //   this.excel.generateExcel(
  //     'Preguntas y respuestas',
  //     headers,
  //     tab,
  //     'Preguntas y respuestas',
  //     aligment,
  //     formato
  //   );
  // }
  public exportPreguntasRespuestas() {
    const tab: any[] = [];
    const processNode = (node: any) => {
      tab.push([
        node.name,
        '',
        node.ponderacion
      ]);
      if (node.questions?.length) {
        for (const question of node.questions) {
          tab.push([
            question.descripcion,
            question.respuestas.find(
              r => Number(r.id) === Number(question.respuesta)
            )?.respuesta ?? '-',
            Number(question.ponderacion)
          ]);
        }
      }
      if (node.elementos?.length) {
        for (const child of node.elementos) {
          processNode(child);
        }
      }
    };
    for (const element of this.questionarySelect.elementos) {
      processNode(element);
    }
    const headers = [
      'Categoria / Elemento / Pregunta',
      'Respuesta',
      'Ponderación'
    ];
    const formato = [
      FormatText.TEXT,
      FormatText.TEXT,
      FormatText.NUMBERDEC
    ];
    const aligment = [
      Aligment.LEFT,
      Aligment.LEFT,
      Aligment.RIGHT
    ];

    this.excel.generateExcel(
      'Preguntas y respuestas',
      headers,
      tab,
      'Preguntas y respuestas',
      aligment,
      formato
    );
  }
}
